import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { BrandListWidget } from 'widgets/content/ui/BrandListWidget';
import { useParams } from 'react-router-dom';

export const BrandsPage = () => {
  const { app_type } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle(`Бренды ${app_type?.toUpperCase()}`));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <BrandListWidget />;
};
